<template>
    <st-modal
        ref="st-edit-document-series-modal"
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('DOCUMENT_SERIES.MODALS.EDIT_TITLE')"
    >
        <template #body>
            <document-series-form
                @cancel="hide"
                @submit="submit"
                :series="selectedItem"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('DOCUMENT_SERIES.MODALS.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('DOCUMENT_SERIES.MODALS.SAVE') }}
                        </st-button>
                    </div>
                </template>
            </document-series-form>
        </template>
    </st-modal>
</template>

<script>
import DocumentSeriesForm from './DocumentSeriesForm.vue';

export default {
    name: 'EditDocumentSeriesModal',
    components: {
        DocumentSeriesForm,
    },
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-edit-document-series-modal'].show();
        },
        hide() {
            this.$refs['st-edit-document-series-modal'].hide();
        },
        submit(series) {
            this.$emit('submit', series);
        },
    },
}
</script>